import { SvgIcon } from "@mui/material";

export const EuIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
        <path
          fill="currentColor"
          d="m150 9.99999-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m150 9.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M169.02115 23.81966h-20.00002v10" />
        <path
          fill="currentColor"
          d="m169.02115 23.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m161.7557 46.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m161.7557 46.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m138.2443 46.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m138.2443 46.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m130.97885 23.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M130.97885 23.81966h20.00002v10M210 26.07699l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m210 26.07699 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M229.02115 39.89666h-20.00002v10" />
        <path
          fill="currentColor"
          d="m229.02115 39.89666-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m221.7557 62.25735-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m221.7557 62.25735-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m198.2443 62.25735 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m198.2443 62.25735 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m190.97885 39.89666 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M190.97885 39.89666h20.00002v10M253.923 69.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m253.923 69.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M272.94415 83.81966h-20.00002v10" />
        <path
          fill="currentColor"
          d="m272.94415 83.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m265.6787 106.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m265.6787 106.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m242.1673 106.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m242.1673 106.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m234.90185 83.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M234.90185 83.81966h20.00002v10M270 129.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m270 129.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M289.02115 143.81966h-20.00002v10" />
        <path
          fill="currentColor"
          d="m289.02115 143.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m281.7557 166.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m281.7557 166.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m258.2443 166.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m258.2443 166.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m250.97885 143.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M250.97885 143.81966h20.00002v10M253.923 189.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m253.923 189.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M272.94415 203.81966h-20.00002v10" />
        <path
          fill="currentColor"
          d="m272.94415 203.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m265.6787 226.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m265.6787 226.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m242.1673 226.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m242.1673 226.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m234.90185 203.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M234.90185 203.81966h20.00002v10M210 233.92299l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m210 233.92299 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M229.02115 247.74266h-20.00002v10" />
        <path
          fill="currentColor"
          d="m229.02115 247.74266-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m221.7557 270.10335-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m221.7557 270.10335-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m198.2443 270.10335 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m198.2443 270.10335 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m190.97885 247.74266 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M190.97885 247.74266h20.00002v10M150 249.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m150 249.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M169.02115 263.81966h-20.00002v10" />
        <path
          fill="currentColor"
          d="m169.02115 263.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m161.7557 286.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m161.7557 286.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m138.2443 286.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m138.2443 286.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m130.97885 263.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M130.97885 263.81966h20.00002v10M90 233.92299l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m90 233.92299 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M109.02115 247.74266H89.02113v10" />
        <path
          fill="currentColor"
          d="m109.02115 247.74266-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m101.7557 270.10335-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m101.7557 270.10335-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m78.2443 270.10335 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m78.2443 270.10335 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m70.97885 247.74266 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M70.97885 247.74266h20.00002v10M46.077 189.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m46.077 189.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M65.09815 203.81966H45.09813v10" />
        <path
          fill="currentColor"
          d="m65.09815 203.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m57.8327 226.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m57.8327 226.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m34.3213 226.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m34.3213 226.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m27.05585 203.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M27.05585 203.81966h20.00002v10M30 129.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m30 129.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M49.02115 143.81966H29.02113v10" />
        <path
          fill="currentColor"
          d="m49.02115 143.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="m41.7557 166.18035-6.18033-19.02114-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m41.7557 166.18035-16.18034-11.75572 5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m18.2443 166.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m18.2443 166.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m10.97885 143.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M10.97885 143.81966h20.00002v10M46.077 69.99999l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m46.077 69.99999 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M65.09815 83.81966H45.09813v10" />
        <path
          fill="currentColor"
          d="m65.09815 83.81966-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M57.8327 106.18035 51.65238 87.1592l-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="M57.8327 106.18035 41.65237 94.42463l5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m34.3213 106.18035 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m34.3213 106.18035 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m27.05585 83.81966 16.18036 11.7557 5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M27.05585 83.81966h20.00002v10M90 26.07699l-6.18034 19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m90 26.07699 6.18034 19.02114-9.51057 3.09017"
        />
        <path fill="currentColor" d="M109.02115 39.89666H89.02113v10" />
        <path
          fill="currentColor"
          d="m109.02115 39.89666-16.18036 11.7557-5.87785-8.09017"
        />
        <path
          fill="currentColor"
          d="M101.7557 62.25735 95.57538 43.2362l-9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="M101.7557 62.25735 85.57537 50.50163l5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m78.2443 62.25735 16.18034-11.75572-5.87786-8.09017"
        />
        <path
          fill="currentColor"
          d="m78.2443 62.25735 6.18033-19.02114 9.51057 3.09017"
        />
        <path
          fill="currentColor"
          d="m70.97885 39.89666 16.18036 11.7557 5.87785-8.09017"
        />
        <path fill="currentColor" d="M70.97885 39.89666h20.00002v10" />
      </svg>
    </SvgIcon>
  );
};

EuIcon.displayName = "European Parliament";
